export default __webpack_public_path__ + "static/media/zendesk.185eba95.svg";